import { IconButton, Card, Typography, Stack, Avatar, Box, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import DataTable from "examples/Tables/DataTable";
import { useSelector } from "react-redux";

const getPlanRank = (plan) => {
  switch (plan) {
    case "UNLIMITED":
      return 4;
    case "GROWTH":
      return 3;
    case "STARTER":
      return 2;
    case "Free":
      return 1;
    default:
      return 0;
  }
};

const getActionDisplay = (currentPlan, previousPlan) => {
  if (!previousPlan || currentPlan.action === "install") {
    return {
      text: "Install",
      color: "success",
    };
  }

  if (currentPlan.action === "uninstall") {
    return {
      text: "Uninstall",
      color: "error",
    };
  }

  const currentPlanRank = getPlanRank(currentPlan.plan);
  const previousPlanRank = getPlanRank(previousPlan.plan);
  const currentPrice = parseFloat(currentPlan.price) || 0;
  const previousPrice = parseFloat(previousPlan.price) || 0;

  if (currentPlanRank > previousPlanRank) {
    return {
      text: "Upgrade",
      color: "info",
    };
  } else if (currentPlanRank < previousPlanRank) {
    return {
      text: "Downgrade",
      color: "warning",
    };
  } else {
    if (currentPrice > previousPrice) {
      return {
        text: "Upgrade",
        color: "info",
      };
    } else if (currentPrice < previousPrice) {
      return {
        text: "Downgrade",
        color: "warning",
      };
    }
  }
};

const columns = [
  { Header: "plan", accessor: "plan", align: "left" },
  { Header: "action", accessor: "action", align: "left" },
  { Header: "action at", accessor: "actionAt", align: "left" },
  { Header: "code", accessor: "code", align: "left" },
];

const PlanTable = () => {
  const shopInfo = useSelector((state) => state.shop);

  const rows =
    shopInfo?.plans?.length > 0
      ? shopInfo?.plans
          .filter((plan) => plan.action !== "cancel")
          .map((plan, index, filteredPlans) => {
            const previousPlan = index < filteredPlans.length - 1 ? filteredPlans[index + 1] : null;
            const actionDisplay = getActionDisplay(plan, previousPlan);

            if (!actionDisplay) return null;

            return {
              plan: (
                <Stack direction="row" spacing={1}>
                  <Typography variant="h6">
                    {plan.price ? `${plan.plan} - ${plan.price}` : plan.plan}
                  </Typography>
                  <MDBadge color="dark" badgeContent={plan.planType} />
                </Stack>
              ),
              action: <MDBadge badgeContent={actionDisplay.text} color={actionDisplay.color} />,
              actionAt: <Typography variant="h6">{plan.actionAt.split(" ")[0]}</Typography>,
              code: <Typography variant="h6">{plan.code ? plan.code : ""}</Typography>,
            };
          })
          .filter(Boolean)
      : [];
  return (
    <Card sx={{ marginTop: 3 }}>
      <MDBox pt={3}>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        ></DataTable>
      </MDBox>
    </Card>
  );
};

export default PlanTable;
